import type { InventoryRow, MonthData } from "../types";

const SECTION_KEYS: Record<string, "raw_materials" | "packaging" | "finished_goods"> = {
  "Raw Materials": "raw_materials",
  Packaging: "packaging",
  "Finished Goods": "finished_goods",
};

export function parseMarkdown(content: string): MonthData {
  const data: MonthData = { raw_materials: [], packaging: [], finished_goods: [] };
  const lines = content.split("\n");
  let i = 0;

  while (i < lines.length) {
    const line = lines[i].trim();
    if (line.startsWith("## ")) {
      const sectionName = line.slice(3).trim();
      const key = SECTION_KEYS[sectionName];
      if (key) {
        i++;
        const sectionLines: string[] = [];
        while (i < lines.length && !lines[i].trim().startsWith("## ")) {
          sectionLines.push(lines[i]);
          i++;
        }
        data[key] = parseTableRows(sectionLines);
        continue;
      }
    }
    i++;
  }

  return data;
}

function parseTableRows(lines: string[]): InventoryRow[] {
  const rows: InventoryRow[] = [];
  let inTable = false;
  let inHeaderSep = false;

  for (const line of lines) {
    const trimmed = line.trim();
    if (!trimmed) {
      if (inTable && inHeaderSep) break;
      continue;
    }
    if (!trimmed.startsWith("|")) {
      if (inTable) break;
      continue;
    }

    const parts = trimmed
      .split("|")
      .map((s) => s.trim())
      .filter((s) => s.length > 0);

    if (!inTable) {
      inTable = true;
      inHeaderSep = true;
      continue;
    }

    if (inHeaderSep) {
      inHeaderSep = false;
      continue;
    }

    if (parts.length >= 5) {
      rows.push({
        item: parts[0],
        quantity: parseFloat(parts[1].replace(/,/g, "")) || 0,
        unit: parts[2],
        unit_price: parseFloat(parts[3].replace(/,/g, "")) || 0,
        total: parseFloat(parts[4].replace(/,/g, "")) || 0,
      });
    }
  }

  return rows;
}

function serializeTable(rows: InventoryRow[]): string {
  let s = "| Item | Quantity | Unit | Price | Total |\n|------|----------|------|-------|-------|\n";
  for (const row of rows) {
    s += `| ${row.item} | ${row.quantity} | ${row.unit} | ${row.unit_price.toFixed(2)} | ${row.total.toFixed(2)} |\n`;
  }
  return s;
}

export function serializeMarkdown(month: string, data: MonthData): string {
  let s = `# Mavelux Ledger — ${month}\n\n`;
  s += "## Raw Materials\n\n";
  s += serializeTable(data.raw_materials);
  s += "\n## Packaging\n\n";
  s += serializeTable(data.packaging);
  s += "\n## Finished Goods\n\n";
  s += serializeTable(data.finished_goods);
  return s;
}
